import {csvToArray} from '@netx/core-next/utils/array';
import {isEmptyValue} from '@netx/core-components/Form/utils';
import base from './base';

export const tag = (value: any) => {
	// DAM-15267 - if there are no commas, one value, the regex in csvToArray()
	// will return null if the single value contains a single apostrophe
	if (typeof value === 'string' && value.indexOf(',') > -1) {
		value = csvToArray(value);
	}
	if (!isEmptyValue(value) && !Array.isArray(value)) value = [value];
	// empty smart labels will parse through as literally "" - we want to treat that as empty
	if (value?.length === 1 && value[0] === '""') value = [];
	return base(value) || [];
};

export default tag;
